var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-radio-group',_vm._g(_vm._b({staticClass:"raido-group",attrs:{"options":_vm.listOptions}},'a-radio-group',_vm.$props,false),_vm.$listeners),[_c('span',{staticClass:"font-grey"},[_vm._v("暂无合同信息")])])}
var staticRenderFns = []

export { render, staticRenderFns }